<template>
    <InformeCard id="accesos" name="accesos" collapsable="true" title="Accesos" v-if="sesiones && sesiones.length === 1">
        <div class="table-responsive">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>Zona</th>
                        <th>Abonados</th>
                        <th>Entradas</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(zona, index) in zonas">
                        <tr :key="index" v-if="zona.name.toUpperCase() !== 'INTERNACIONAL'">
                            <td>{{zona.name}}</td>
                            <td>{{zona.abonos_validados}}</td>
                            <td>{{zona.entradas_online_validadas}}</td>
                            <td>{{zona.abonos_validados + zona.entradas_online_validadas}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>        
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id', 'sesiones'],
        data() {
            return {
                zonas: null
            }
        },
        mounted() {
            const params = {
                filters: {
                    evento_id: this.event_id,
                    sesion_id: this.sesiones[0].id
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                this.zonas = res.data;
            });
        },
        components: {
            InformeCard
        }
    }
</script>